export enum OverdueNoticeTypeEnum {
  MANUAL = 'MANUAL',
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD'
}
